
//Aqui se defiene las variables para el control y manejo de los input
export const initialRecover = {
  email: "",
  selectCorreo: "",
};

export const newPassword = {
  newPass: '',
  newPassConfirm: ''
}
